import { Component, ViewChild, Input } from '@angular/core';
import { RmtNewEntryComponent } from '../rmt-new-entry/rmt-new-entry';
import * as $ from 'jquery'

@Component({
  selector: 'rmt-remove-entry',
  templateUrl: 'rmt-remove-entry.html'
})
export class RmtRemoveEntryComponent {
  @ViewChild('removeEntry') removeEntry;
  @Input() active: boolean = true;
  @Input() transitionPromise;
  removed: boolean = false;

  constructor() {
  }

  ngOnChanges() {
    if (this.active && !this.removed && this.removeEntry) {
      RmtNewEntryComponent.pendingAnimations(this, this.transitionPromise);        
      this.removed = true;
      window.setTimeout(() => {
        const virtual = $(this.removeEntry.nativeElement).parents('rmt-virtual-scroll-item');
        if (virtual && virtual.length > 0) {
          virtual[0].style.transition = '300ms linear max-height';
          virtual[0].style.maxHeight = virtual[0].getAttribute('height');
        }
        const height = $(this.removeEntry.nativeElement.parentNode).outerHeight();
        this.removeEntry.nativeElement.style.maxHeight = parseInt(height.toString()) + 'px';
        $(this.removeEntry.nativeElement).addClass('anim-fadeout');
        window.setTimeout(() => {
          this.removeEntry.nativeElement.style.maxHeight = '0px';
          if (virtual && virtual.length > 0)
            virtual[0].style.maxHeight = '0px';
        }, 100);
        window.setTimeout(() => {
          $(this.removeEntry.nativeElement).removeClass('anim-fadeout');
          this.removeEntry.nativeElement.style.height = '0px';
          RmtNewEntryComponent.finishAnimations(this, this.transitionPromise);
        }, 600);        
      }, 500);
    }
    else if (!this.active && this.removed) {
      this.removed = false;
      this.removeEntry.nativeElement.style.height = 'auto';
      this.removeEntry.nativeElement.style.maxHeight = 'none';
    }
  }  
}



// WEBPACK FOOTER //
// ./src/components/rmt-remove-entry/rmt-remove-entry.ts